// This file exports the static images for the room slider
export const roomSliderImages = {
  queen: [
    "/images/rooms/queen/img1.jpeg",
    "/images/rooms/queen/img2.jpeg",
    "/images/rooms/queen/img3.jpeg",
    "/images/rooms/queen/img4.jpeg",
    "/images/rooms/queen/img5.jpeg",
    "/images/rooms/queen/img6.jpeg",
    "/images/rooms/queen/img7.jpeg",
    "/images/rooms/queen/img8.jpeg",
    "/images/rooms/queen/img9.jpeg",
  ],
  family: [
    "/images/rooms/family/img1.jpeg",
    "/images/rooms/family/img2.jpeg",
    "/images/rooms/family/img3.jpeg",
    "/images/rooms/family/img4.jpeg",
    "/images/rooms/family/img5.jpeg",
    "/images/rooms/family/img6.jpeg",
  ],
  twin: [
    "/images/rooms/twin/img1.jpeg",
    "/images/rooms/twin/img2.jpeg",
    "/images/rooms/twin/img3.jpeg",
    "/images/rooms/twin/img4.jpeg",
    "/images/rooms/twin/img5.jpeg",
    "/images/rooms/twin/img6.jpeg",
    "/images/rooms/twin/img7.jpeg",
    "/images/rooms/twin/img8.jpeg",
  ],

  // Specific Room Sequences for Diversification
  queenRoom: [
    "/images/rooms/queen/img1.jpeg",
    "/images/rooms/queen/img2.jpeg",
    "/images/rooms/queen/img3.jpeg",
    "/images/rooms/queen/img4.jpeg",
    "/images/rooms/queen/img5.jpeg",
    "/images/rooms/queen/img6.jpeg",
    "/images/rooms/queen/img7.jpeg",
    "/images/rooms/queen/img8.jpeg",
    "/images/rooms/queen/img9.jpeg",
  ],
  deluxeRoom: [
    "/images/rooms/queen/img6.jpeg",
    "/images/rooms/queen/img7.jpeg",
    "/images/rooms/queen/img8.jpeg",
    "/images/rooms/queen/img9.jpeg",
    "/images/rooms/queen/img1.jpeg",
    "/images/rooms/queen/img2.jpeg",
    "/images/rooms/queen/img3.jpeg",
    "/images/rooms/queen/img4.jpeg",
    "/images/rooms/queen/img5.jpeg",
  ],
  deluxeTwin: [
    "/images/rooms/twin/img1.jpeg",
    "/images/rooms/twin/img2.jpeg",
    "/images/rooms/twin/img3.jpeg",
    "/images/rooms/twin/img4.jpeg",
    "/images/rooms/twin/img5.jpeg",
    "/images/rooms/twin/img6.jpeg",
    "/images/rooms/twin/img7.jpeg",
    "/images/rooms/twin/img8.jpeg",
  ],
  familyRoom4: [
    "/images/rooms/family/img1.jpeg",
    "/images/rooms/family/img2.jpeg",
    "/images/rooms/family/img3.jpeg",
    "/images/rooms/family/img4.jpeg",
    "/images/rooms/family/img5.jpeg",
    "/images/rooms/family/img6.jpeg",
  ],
  familyRoom2: [
    "/images/rooms/family/img4.jpeg",
    "/images/rooms/family/img5.jpeg",
    "/images/rooms/family/img6.jpeg",
    "/images/rooms/family/img1.jpeg",
    "/images/rooms/family/img2.jpeg",
    "/images/rooms/family/img3.jpeg",
  ],
};
